import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Logout } from '@carbon/icons-react';
import {
  SideNav,
  SideNavItems,
  SideNavLink,
  SideNavMenu,
  SideNavMenuItem,
  Theme,
} from '@carbon/react';
import { useDispatch } from 'react-redux';
import { isLoggedIn, loggedOutUser } from '../../Utils/common';
import { removeUserLoginDetails } from '../../Redux/Actions/User';
import {
  superAdminMenuLists,
  adminMenuLists,
  userMenuLists,
} from './SidebarMenuList';
export default function SideBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [authType, setAuthType] = useState(null);
  const [menuList, setMenuList] = useState(userMenuLists);

  useEffect(() => {
    const info = isLoggedIn();
    setAuthType(info?.role);
  }, []);

  useEffect(() => {
    if (authType) {
      switch (authType) {
        case 'admin':
          setMenuList(adminMenuLists);
          break;
        case 'superAdmin':
          setMenuList(superAdminMenuLists);
          break;
        case 'user':
          setMenuList(userMenuLists);
          break;
        default:
          setMenuList(userMenuLists);
          break;
      }
    }
  }, [authType]);

  const handleLogout = () => {
    loggedOutUser();
    dispatch(removeUserLoginDetails());
    navigate('/login');
    window?.google?.accounts?.id?.disableAutoSelect();
  };

  const handleManagePathRedirect = (value) => {
    return navigate(value);
  };

  const handleManageClassName = (value) => {
    return `cursor-pointer ${pathname === value ? 'active-menu' : ''}`;
  };

  return (
    <div>
      <Theme theme="g10">
        <SideNav
          isFixedNav
          expanded={true}
          aria-label="Side navigation"
          className="side-nav"
        >
          {authType && (
            <>
              <SideNavItems>
                {menuList &&
                  menuList.length > 0 &&
                  menuList.map((menu, index) => {
                    if (!menu?.subMenu) {
                      return (
                        <SideNavLink
                          key={index}
                          isActive={menu?.path === pathname}
                          onClick={() => handleManagePathRedirect(menu?.path)}
                          className={handleManageClassName(menu?.path)}
                        >
                          {menu?.title}
                        </SideNavLink>
                      );
                    }
                    return (
                      <SideNavMenu
                        key={index}
                        isActive={pathname.includes(menu?.path)}
                        title={menu?.title}
                        className={handleManageClassName(menu?.path)}
                        defaultExpanded={pathname.includes(menu?.path)}
                      >
                        {menu?.menu &&
                          menu?.menu?.length > 0 &&
                          menu?.menu?.map((subMenu, index) => {
                            return (
                              <SideNavMenuItem
                                key={index}
                                className={handleManageClassName(subMenu?.path)}
                                isActive={subMenu?.path === pathname}
                                onClick={() =>
                                  handleManagePathRedirect(subMenu?.path)
                                }
                              >
                                {subMenu?.title}
                              </SideNavMenuItem>
                            );
                          })}
                      </SideNavMenu>
                    );
                  })}
              </SideNavItems>
            </>
          )}
          <SideNavItems>
            <SideNavLink onClick={handleLogout} className="cursor-pointer">
              <Logout /> Logout
            </SideNavLink>
          </SideNavItems>
        </SideNav>
      </Theme>
    </div>
  );
}
